<template>
    <div>
        <b-row v-for="(param, index) in list" :key="param.Id" class="mt-2 mb-2">
            <parameter :definition=param @changed="onParametersChanged"/>
        </b-row>
    </div>
</template>

<script>
  import Parameter from './Parameter';

  export default {
    props: {
      list: Array
    },
    data() {
      return {
        // editable: false
      };
    },
    methods: {
      async onParametersChanged(name, value) {
        this.$emit('changed', name, value)
      }
    },
    components: {
      Parameter
    }
  }
</script>

<style>
</style>
